import { consumer, core } from '@tock/coretypes';

export type PartyCollectiveItem = 'order' | 'reservation';
export const varietyToPartyCollectiveItemMap: {
  [K in core.TicketType.Variety | consumer.Offering.Type]: PartyCollectiveItem;
} = {
  DEPOSIT: 'reservation',
  FULL: 'reservation',
  PRIX_FIXE: 'reservation',
  RESERVATION: 'reservation',
  DEPRECATED_EVENT: 'order',
  GA_EVENT: 'order',
  SEATED_EVENT: 'order',
  DEPRECATED_SPECIAL_TABLE: 'reservation',
  ORDER_DELIVERY: 'order',
  ORDER_PICKUP: 'order',
  TABLESIDE: 'order',
};

/**
 * Returns the name of what an individual purchase item is for an offering,
 * such as a ticket or a guest. Used for party size selector where a user selects
 * how many guests or tickets they would like to purchase
 * e.g. RESERVATION -> ticket, SPECIAL_TABLE -> guest, DEPOSIT -> guest
 */
export function offeringPartyCollectiveItem(
  variety?: core.TicketType.Variety | consumer.Offering.Type | null
): PartyCollectiveItem {
  return varietyToPartyCollectiveItemMap[variety ?? 'RESERVATION'];
}
